import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import './avatar.scss';
import Image from '../image/image';

const AvatarThemes = {
  LIGHT: 'light',
  DARK: 'dark',
};

const AvatarSizes = {
  SMALL: 'size-s',
  MEDIUM: 'size-m',
  LARGE: 'size-l',
};

const AvatarStatus = {
  ONLINE: 'status-online',
  OFFLINE: 'status-offline',
};

const AvatarImage = ({
  image, nameInitials, status, size,
}) => (
  <div className={clsx('avatar-image-cont', status, size)}>
    <Image src={image} alt="avatar-image" className="avatar-image" />
    <div className="avatar-status" />
    <div className="avatar-initials">{nameInitials}</div>
  </div>
);

AvatarImage.propTypes = {
  nameInitials: PropTypes.string,
  image: PropTypes.string,
  status: PropTypes.oneOf([...Object.values(AvatarStatus), '']),
  size: PropTypes.oneOf(Object.values(AvatarSizes)),
};

AvatarImage.defaultProps = {
  nameInitials: '',
  image: '',
  status: '',
  size: AvatarSizes.MEDIUM,
};

const Avatar = React.forwardRef(({
  name, nameInitials, description, image, theme, size, status, showImage, showLabels,
}, ref) => (
  <div ref={ref} className={clsx('avatar-cont', size, theme)}>
    {showImage ? (
      <AvatarImage
        image={image}
        nameInitials={nameInitials}
        status={status}
        size={size}
      />
    ) : null}
    {showLabels && (name || description) && (
      <div className="avatar-labels">
        {name && <div className="avatar-pri-text">{name}</div>}
        {description && <div className="avatar-sec-text">{description}</div>}
      </div>
    )}
  </div>
));

Avatar.propTypes = {
  name: PropTypes.string,
  nameInitials: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
  showImage: PropTypes.bool,
  showLabels: PropTypes.bool,
  theme: PropTypes.oneOf(Object.values(AvatarThemes)),
  size: PropTypes.oneOf(Object.values(AvatarSizes)),
  status: PropTypes.oneOf([...Object.values(AvatarStatus), '']),
};

Avatar.defaultProps = {
  name: '',
  nameInitials: '',
  description: '',
  image: '',
  showImage: true,
  showLabels: true,
  theme: AvatarThemes.DARK,
  size: AvatarSizes.MEDIUM,
  status: '',
};

export {
  Avatar as default,
  AvatarImage,
  AvatarThemes,
  AvatarSizes,
  AvatarStatus,
};
